import { useEffect, useState } from "react";
import { get } from "../utils/request";

export const DEFAULT_SERVICE_AVAILABILITY = Object.freeze({
  esim: true,
  flights: true,
  thingsToDo: true,
  airportLounge: true,
  hotels: false,
});

export default function useServiceAvailability() {
  const [services, setServices] = useState(DEFAULT_SERVICE_AVAILABILITY);

  useEffect(() => {
    let active = true;
    get("/appConfig/serviceAvailability")
      .then((result) => {
        if (active && result) {
          setServices({ ...DEFAULT_SERVICE_AVAILABILITY, ...result });
        }
      })
      .catch(() => {
        // Keep safe product defaults when configuration is temporarily unavailable.
      });
    return () => { active = false; };
  }, []);

  return services;
}
